module.exports = __webpack_public_path__ + "static/media/joinme_laptop.d0dca695.png";